import { render, staticRenderFns } from "./servicos-pesquisa.vue?vue&type=template&id=3b0ffef2&scoped=true&"
import script from "./servicos-pesquisa.vue?vue&type=script&lang=js&"
export * from "./servicos-pesquisa.vue?vue&type=script&lang=js&"
import style0 from "./servicos-pesquisa.vue?vue&type=style&index=0&id=3b0ffef2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0ffef2",
  null
  
)

export default component.exports